import * as React from "react";

export const IconImportFile = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
	<svg
		width="14"
		height="17"
		viewBox="0 0 14 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M8.33333 0L1.66667 0C0.75 0 0.00833352 0.75 0.00833352 1.66667L0 15C0 15.9167 0.741666 16.6667 1.65833 16.6667L11.6667 16.6667C12.5833 16.6667 13.3333 15.9167 13.3333 15L13.3333 5L8.33333 0ZM11.6667 15L1.66667 15L1.66667 1.66667L7.5 1.66667L7.5 5.83333L11.6667 5.83333V15Z"
			fill="currentColor"
		/>
		<path
			d="M10 10.8263L8.825 9.6513L7.5 10.968L7.5 7.5013L5.83333 7.5013V10.968L4.50833 9.64297L3.33333 10.8263L6.65833 14.168L10 10.8263Z"
			fill="currentColor"
		/>
	</svg>
);
